<mat-card class="daxa-card plant-status-graph-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mb-0">
                Plant status
            </h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div id="plant_status_graph"></div>
    </mat-card-content>
</mat-card>